import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	searchPlaceholder: {
		id: 'servicedesk-insight-object-schema-page.page-content.loaded.page-header.editable-object-type.editable-icon.search-placeholder',
		defaultMessage: 'Enter an icon name...',
		description: 'Prompt for the user to enter an icon name to search',
	},
});
